import { render, staticRenderFns } from "./DashboardCardRemainingCoins.vue?vue&type=template&id=e998c5ba"
import script from "./DashboardCardRemainingCoins.vue?vue&type=script&lang=js"
export * from "./DashboardCardRemainingCoins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports